module.exports = __webpack_public_path__ + "static/img/jman-logo.d6fa914.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jman-logo.svg
// module id = ufwM
// module chunks = 1